import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ParametreService {
private openModalSubject = new Subject<{ component: string; action: string; subType?: string }>();
  openModal$ = this.openModalSubject.asObservable();
    private addItemSource = new Subject<{ subType: string, idStation: number }>();
    addItem$ = this.addItemSource.asObservable();
  triggerModal(component: string, action: string, subType?: string) {
    this.openModalSubject.next({ component, action, subType });
  }
    triggerAddItem(subType: string, idStation: number) {
        this.addItemSource.next({ subType, idStation });
    }
}

